
export default function B2BOffer() {
  const scrollToContact = () => {
    const contactSection = document.getElementById('contact-form');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="py-24 bg-[#fafafa]">
      <div className="max-w-5xl mx-auto px-6">
        <div className="bg-[#1a1a2e] rounded-3xl p-12 text-white text-center relative overflow-hidden">
          {/* Background Decoration */}
          <div className="absolute top-0 right-0 w-64 h-64 bg-amber-400/10 rounded-full blur-3xl"></div>
          <div className="absolute bottom-0 left-0 w-48 h-48 bg-[#8E7CC3]/10 rounded-full blur-3xl"></div>
          
          <div className="relative">
            {/* Special Price Badge */}
            <div className="inline-flex items-center gap-2 bg-gradient-to-r from-amber-400 to-amber-500 text-[#1a1a2e] px-6 py-2 rounded-full text-sm font-bold mb-6">
              <i className="ri-vip-crown-2-line text-lg"></i>
              <span>法人様限定 特別価格適用</span>
            </div>
            
            <h2 className="text-4xl font-bold mb-4">法人様限定の特別サポート</h2>
            <p className="text-lg text-white/80 mb-8">
              導入台数に応じた<span className="text-amber-400 font-bold">ボリュームディスカウント</span>をご用意<br />
              まずはお気軽にお見積もりをご依頼ください
            </p>
            
            {/* Benefits List */}
            <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-10">
              <div className="flex flex-col items-center">
                <div className="w-16 h-16 bg-amber-400/20 rounded-full flex items-center justify-center mb-3">
                  <i className="ri-percent-line text-3xl text-amber-400"></i>
                </div>
                <div className="text-sm font-medium">特別価格適用</div>
                <div className="text-xs text-white/60 mt-1">台数に応じて割引</div>
              </div>
              <div className="flex flex-col items-center border-l border-white/20">
                <div className="w-16 h-16 bg-[#8E7CC3]/20 rounded-full flex items-center justify-center mb-3">
                  <i className="ri-file-list-3-line text-3xl text-[#B8A9D9]"></i>
                </div>
                <div className="text-sm font-medium">無料見積もり</div>
                <div className="text-xs text-white/60 mt-1">最短即日対応</div>
              </div>
              <div className="flex flex-col items-center border-l border-white/20">
                <div className="w-16 h-16 bg-[#8E7CC3]/20 rounded-full flex items-center justify-center mb-3">
                  <i className="ri-truck-line text-3xl text-[#B8A9D9]"></i>
                </div>
                <div className="text-sm font-medium">一括配送対応</div>
                <div className="text-xs text-white/60 mt-1">全国対応可能</div>
              </div>
              <div className="flex flex-col items-center border-l border-white/20">
                <div className="w-16 h-16 bg-[#8E7CC3]/20 rounded-full flex items-center justify-center mb-3">
                  <i className="ri-tools-line text-3xl text-[#B8A9D9]"></i>
                </div>
                <div className="text-sm font-medium">設置サポート</div>
                <div className="text-xs text-white/60 mt-1">オプション対応</div>
              </div>
            </div>

            {/* CTA Button */}
            <div className="relative inline-block">
              <button
                onClick={scrollToContact}
                className="bg-gradient-to-r from-amber-400 to-amber-500 text-[#1a1a2e] px-12 py-5 rounded-full text-lg font-bold hover:from-amber-300 hover:to-amber-400 transition-all flex items-center space-x-3 shadow-xl whitespace-nowrap cursor-pointer mx-auto"
              >
                <i className="ri-building-2-line text-xl"></i>
                <span>法人特別価格でお見積もり</span>
                <i className="ri-arrow-right-line text-xl"></i>
              </button>
              <div className="mt-3 text-xs text-white/60">
                <i className="ri-time-line mr-1"></i>
                30秒で完了・最短即日回答
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
